import { useCallback } from 'react';

import type { SmsTemplate } from 'api/resources/smsTemplates/types';
import NewSmsTemplatesModal from 'components/organisms/SmsTemplatesModal';

interface Props {
  onCreate?: (data: SmsTemplate) => void;
  onCancel?: (errorMessage: string) => void;
}

const Sms = ({ onCreate, onCancel }: Props) => {
  const onUpsertSuccess = useCallback(
    (template_name: string, _?: string, id?: string) => {
      onCreate?.({
        template_name,
        id,
      } as SmsTemplate);
    },
    [onCreate],
  );

  const onCancelUpsert = useCallback(() => {
    onCancel?.('Error creating SMS template');
  }, [onCancel]);

  return (
    <NewSmsTemplatesModal
      isRequesting={false}
      open
      onClose={onCancelUpsert}
      onUpsertError={onCancelUpsert}
      onUpsertSuccess={onUpsertSuccess}
    />
  );
};

export default Sms;
